import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from 'axios';
function uploadFormDataToS3(_x) {
  return _uploadFormDataToS.apply(this, arguments);
}
function _uploadFormDataToS() {
  _uploadFormDataToS = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var policy, file, onProgress, form, counter;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          policy = _ref.policy, file = _ref.file, onProgress = _ref.onProgress;
          form = new FormData();
          Object.entries(policy.fields).forEach(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];
            // Add metadata and any required fields
            if (typeof value === 'string' || value instanceof Blob) {
              form.append(key, value);
            }
          });
          form.append('file', file);
          counter = 0;
          return _context.abrupt("return", axios.post(policy.url, form, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function onUploadProgress(event) {
              if (!onProgress) {
                return;
              }
              var progress = event.total ? +(event.loaded / event.total) * 100 : 0;
              var isSignificantDifference = Math.abs(progress - counter) > 5;
              if (isSignificantDifference) {
                onProgress(progress);
                counter = progress;
              }
            }
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _uploadFormDataToS.apply(this, arguments);
}
export default uploadFormDataToS3;